import { render, staticRenderFns } from "./dietDialog.vue?vue&type=template&id=0fbedeb4&scoped=true"
import script from "./dietDialog.vue?vue&type=script&lang=js"
export * from "./dietDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbedeb4",
  null
  
)

export default component.exports